<template>
  <div class="test-wrapper">
    <div class="test" v-for="test in tests" :key="test.id">
      <span class="test-header">
        <PlayIcon
          v-if="!testStatus[test.id].ran && !testStatus[test.id].running"
        />
        <SuccessIcon
          v-if="
            testStatus[test.id].ran &&
              testStatus[test.id].passed &&
              !testStatus[test.id].running
          "
        />
        <FailIcon
          v-if="
            testStatus[test.id].ran &&
              !testStatus[test.id].passed &&
              !testStatus[test.id].running
          "
        />
        <div class="lds-ring" v-if="testStatus[test.id].running">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <span class="test-name">{{ test.name }}</span>
        <span @click="runTest(test)" class="test-header__run-test">
          RUN TEST
        </span>
      </span>
      <div class="test-run-wrapper">
        <div class="prism-code">
          <prism :language="exercise.language">{{ test.code }}</prism>
        </div>
        <div class="test-output" v-if="testStatus[test.id].ran">
          <pre>{{ testStatus[test.id].output }}</pre>
        </div>
      </div>
    </div>
    <ActionLoader
      v-if="loading && tests && !tests.length"
      name="ball-clip-rotate"
      loaderClass="level__loading-spinner"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Prism from 'vue-prism-component'
import PlayIcon from '@/assets/icons/course/exercise/play-test-icon.svg'
import SuccessIcon from '@/assets/icons/course/exercise/success-icon.svg'
import FailIcon from '@/assets/icons/course/exercise/fail-icon.svg'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'Tests',
  components: {
    Prism,
    PlayIcon: { ...PlayIcon, name: 'PlayIcon' },
    SuccessIcon: { ...SuccessIcon, name: 'SuccessIcon' },
    FailIcon: { ...FailIcon, name: 'FailIcon' },
    ActionLoader,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      tests: state => state.exercises.currentTests,
      testStatus: state => state.exercises.currentTestsStatus,
      currentFlavor: state => state.exercises.currentFlavor,
    }),
  },
  methods: {
    async runTest(test) {
      this.$store.dispatch('exercises/runExerciseTest', {
        exerciseId: this.exercise.id,
        testId: test.id,
        code: this.code,
        flavor: this.currentFlavor,
      })
    },
    async getTests() {
      this.loading = true
      await this.$store.dispatch(
        'exercises/getExerciseTestsByExerciseId',
        this.exercise.id
      )
      this.loading = false
    },
  },
  async mounted() {
    await this.getTests()
  },
  watch: {
    exercise(newValue) {
      this.getTests()
    },
  },
}
</script>
<style lang="scss" scoped>
.test-wrapper {
  .prism-code {
    background-color: #000000;
    font-size: 0.8em;
    padding: 20px 20px;
  }
  .test-header {
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    .test-name {
      margin-left: 10px;
    }
    &__run-test {
      background: rgb(91, 91, 94);
      color: white;
      padding: 5px 10px;
      border-radius: 15px;
      font-size: 9px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .test {
    margin-bottom: 30px;
  }
  .test-run-wrapper {
    margin-top: 15px;
    border: 1px solid #424040;
    .test-output {
      padding: 20px 30px;
      color: var(--red);
      font-family: var(--font-roboto);
      overflow: scroll;
    }
  }
}
</style>
